























import {Vue, Component, Prop} from 'vue-property-decorator'
import {$} from '@/facade'

@Component
export default class NavbarWalletSessionDisconnected extends Vue {
  openConnectWalletModal() {
    $.modal.open('connectWalletModal')
  }
}
